import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1dacd83a&xmlns%3Av-bind=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./App.js?vue&type=script&lang=js&"
export * from "./App.js?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports